// extracted by mini-css-extract-plugin
export default {"element":"MakePhotoIcon_element__zghrT","isDarkMode":"MakePhotoIcon_isDarkMode__owCfA"};